module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/favicon-96x961013594fa8ed568121f39aee4b64e200.png";